<template>
  <div>
    <div v-if="!matches.length" class="tw-py-2.5">
      <div class="tw-p-5 tw-leading-6 tw-bg-white tw-border tw-border-gray-200 tw-shadow-md">
        Sorry, but it looks like your league is still finalising the draw. Please check back soon or
        contact your Club or League.
      </div>
    </div>
    <div v-else>
      <el-row :gutter="20" v-if="((clearance === roles.gamedayAdmin) || (clearance === roles.clubAdmin))&& matches.length">
        <el-col>
          <select
            class="tw-w-full tw-px-2 tw-text-sm tw-text-black tw-placeholder-gray-800 tw-bg-transparent tw-border-b-2 tw-border-gray-200 tw-appearance-none tw-h-9"
            v-model="venueId"
            :class="venueId !== null ? 'tw-font-medium' : 'tw-font-normal'"
          >
            <option disabled selected :value="null">Select A Venue</option>
            <option v-for="{ _id, name } in venues" :label="name" :key="_id" :value="_id">
              {{ name }}
            </option>
          </select>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="((clearance === roles.gamedayAdmin) || (clearance === roles.clubAdmin))&&  matches.length">
        <el-col>
          <el-select
            v-model="competitionIds"
            multiple
            filterable
            :class="
              competitionIds && competitionIds.length > 0 ? 'tw-font-medium' : 'tw-font-normal'
            "
            placeholder="Select Competitions"
          >
            <el-option disabled selected :value="null">Select Competitions</el-option>
            <el-option
              v-for="{ _id, name } in competitions()"
              :label="name"
              :key="_id"
              :value="_id"
            >
              {{ name }}
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <div v-if="upcomingMatches.length">
          <h3 class="tw-py-5 tw-text-lg tw-font-bold">Upcoming Matches</h3>
          <swipe-list :items="upcomingMatches" ref="upcomingList">
            <template v-slot="{ item }">
              <el-col><RefereeMatchCard :match="item" @click="goDetail(item._id)" /></el-col>
            </template>
          </swipe-list>
        </div>
      </el-row>
      <el-row :gutter="20">
        <div v-if="previousMatches.length">
          <h3 class="tw-py-5 tw-text-lg tw-font-bold">Previous Matches</h3>
          <swipe-list :items="previousMatches" ref="previousList">
            <template v-slot="{ item }">
              <el-col><RefereeMatchCard :match="item" @click="goDetail(item._id)" /></el-col>
            </template>
          </swipe-list>
        </div>
      </el-row>
    </div>
  </div>
</template>
<script>
import "vue-swipe-actions/dist/vue-swipe-actions.css";
import { SwipeList } from "vue-swipe-actions";
import _ from "lodash";
import RefereeMatchCard from "../../components/RefereeMatchCard.vue";
import { roles, currentSeason } from "../../utils/constants";

export default {
  name: "refereeAppointment",
  components: {
    RefereeMatchCard,
    SwipeList,
  },
  data() {
    return {
      roles,
      teams: [],
      teamId: null,
      competitionIds: [],
      filteredMatches: [],
      matches: [],
      venues: [],
      venueId: null,
    };
  },
  mounted() {
    this.$store.commit("root/loading", true);

    this.fetchData();
    this.$store.commit("root/loading", false);
    // }
  },
  methods: {
    async fetchData() {
      try {
        const response = await this.$http.get(`/nrl/api/v1/admin/gamedayadmin/`);
        // Handle response data here
        if (response && response.data && response.data.data) {
          const matches = response.data.data;
          if (matches && matches.length) {
            this.matches = matches.filter((x) => !x.meta || (!x.meta.isTba && !x.meta.isBye));
            this.filteredMatches = this.matches;
            const venues = this.filteredMatches.map((match) => match.venue);
            const filteredVenues = venues.filter(venue => venue != null)
            this.venues = filteredVenues.filter(
              (obj, index, self) => index === self.findIndex((t) => t?._id === obj?._id)
            );
          }
        }
        // return response.data; // Return data if needed
      } catch (error) {
        // Handle error here
        console.error("Error fetching data:", error);
        throw error; // Re-throw the error if necessary
      }
    },
    competitions() {
      if (this.matches.length) {
        return _.chain(this.matches).map("competition").uniqBy("_id").sortBy("name")
          .values();
      }
      return [];
    },
    matchTime(dateTime) {
      return this.dayjs(dateTime).format("h:mm a");
    },
    matchDate(dateTime) {
      return this.dayjs(dateTime).format("dddd Do MMMM");
    },
    goDetail(matchId) {
      const match = this.matches.find(x => x._id === matchId);

      if (match && match.status !== "pre-game") {
        this.$customError(`Match has been set to ${match.status}.`);
        return;
      }

      if (match && Math.abs(this.dayjs().diff(match.dateTime, "days", true)) > 8) {
        this.$customError("Match has exceeded 8 days");
        return;
      }

      this.$router.push({
        name: "match.detail",
        params: {
          matchId,
          teamId: this.teamId,
        },
      });
    },
  },
  computed: {
    clearance() {
      return this.$store.getters["user/activeRole"].type;
    },
    upcomingMatches() {
      let matchesUpcoming = this.filteredMatches;

      if (this.competitionIds && this.competitionIds.length > 0 && matchesUpcoming) {
        matchesUpcoming = matchesUpcoming.filter((match) => {
          if (this.competitionIds.includes(match.competition._id)) return match;
        });
      }
      if (this.venueId !== null && matchesUpcoming) {
        matchesUpcoming = matchesUpcoming.filter((match) => {
          if (match.venue._id === this.venueId) return match;
        });
      }

      const currentTime = new Date();
      const time = currentTime.getTime() - 12 * 60 * 60 * 1000;
      //   const time = this.dayjs().subtract(12, "hours").valueOf();

      return _.orderBy(
        matchesUpcoming.filter(x => x.dateTime >= time),
        "dateTime"
      );
    },
    previousMatches() {
      let matchesPrevious = this.filteredMatches;

      if (this.competitionIds && this.competitionIds.length > 0 && matchesPrevious) {
        matchesPrevious = matchesPrevious.filter((match) => {
          if (this.competitionIds.includes(match.competition._id)) return match;
        });
      }
      if (this.venueId !== null && matchesPrevious) {
        matchesPrevious = matchesPrevious.filter((match) => {
          if (match.venue._id === this.venueId) return match;
        });
      }
      const time = this.dayjs().subtract(12, "hours").valueOf();

      return _.orderBy(
        matchesPrevious.filter(x => x.dateTime < time),
        "dateTime"
      );
    },
  },
  watch: {
    teamId: {
      immediate: true,
      handler(val) {
        // reset competition id if user select another team
        if (val !== this.$store.state.app.selectedTeamId && val !== null) {
          this.$store.commit("app/selectTeam", val);
          this.$store.commit("app/selectCompetition", null);
          this.competitionIds = [];
        }
        this.$store.commit("root/loading", true);

        if (val) {
          this.$http.get(`nrl/api/v1/admin/teams/${val}/matches`).then((res) => {
            this.matches = res.data.data;
            // filter out tba or bye game
            if (this.matches && this.matches.length) {
              this.matches = this.matches.filter(
                (x) => !x.meta || (!x.meta.isTba && !x.meta.isBye)
              );
            }
            this.competitionId = this.$store.state.app.selectedCompetitionId;
            this.filteredMatches = this.competitionId
              ? this.matches.filter((match) => match.competition._id === this.competitionId)
              : this.matches;
            this.$store.commit("root/loading", false);
          });
        }
      },
    },
    competitionId: {
      immediate: true,
      handler(val) {
        if (val !== null) {
          this.$store.commit("app/selectCompetition", val);
          if (val) this.filteredMatches = this.matches.filter((x) => x.competition._id === val);
          else this.filteredMatches = this.matches;
        }
      },
    },
  },
};
</script>
<style scoped lang="scss">
select {
  appearance: none; /* Remove default arrow */
  background-image: url("../../assets/chevron_down.svg"); /* Add custom arrow */
  background-position: center right;
  background-repeat: no-repeat;
  background-size: 40px 40px;
  background-position-y: 8px;
}

.el-select {
  appearance: none; /* Remove default arrow */
  background-image: url("../../assets/chevron_down.svg"); /* Add custom arrow */
  background-position: center right;
  background-repeat: no-repeat;
  background-size: 40px 40px;
  background-position-y: 8px;
  @apply tw-w-full tw-px-2 tw-text-sm tw-text-black tw-placeholder-gray-800 tw-bg-transparent tw-border-b-2 tw-border-gray-200 tw-appearance-none tw-h-9;
}

.swipe-item {
  justify-content: center;
  min-width: 100px;
  margin: 5px 0px;
  padding: 10px;
  background-color: orange;
  color: $white;
  display: flex;
  align-items: center;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
h3 {
  text-align: center;
}
.el-col .el-col-24 {
  margin: 5px 0px;
}

.dialog-footer {
  display: flex;
  justify-content: center;
}

.textBox {
  @apply tw-w-full tw-p-2 tw-text-sm tw-text-black tw-placeholder-gray-800 tw-bg-transparent tw-border tw-border-gray-200 tw-shadow-none focus:tw-outline-none tw-h-9;
}
.btn-success {
  @apply tw-justify-center tw-w-full tw-mt-2 tw-mr-2.5 tw-h-10 tw-rounded-lg tw-capitalize tw-text-sm tw-not-italic tw-font-medium tw-leading-11px tw-tracking-normal tw-text-center  tw-text-white  tw-bg-green-700  tw-mb-4 hover:tw-bg-green-300 hover:tw-text-black sm:tw-w-64;
}
.btn-cancel {
  @apply tw-justify-center tw-w-full tw-h-10 tw-rounded-lg tw-capitalize tw-text-sm tw-not-italic tw-font-medium tw-leading-11px tw-tracking-normal tw-text-center  tw-text-black  tw-bg-none tw-border-2 tw-border-green-700  hover:tw-border-green-300 sm:tw-w-64;
}
</style>
